/*
 * @Author: LGY 18588437913@163.com
 * @Date: 2023-02-15 09:52:14
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-20 11:49:14
 * @FilePath: /dz-signup-stupc/src/utils/idcard.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default function getDate(idcard) {
  const birth =
    idcard.substring(6, 10) +
    "-" +
    idcard.substring(10, 12) +
    "-" +
    idcard.substring(12, 14);
  return birth;
}
